/**
 * Content-shaped gibberish ("greeking") for the column preview placeholder
 * cells. Pure and deterministic: the same (field, rowIndex) always yields the
 * same cell. The text is lowercase letters and single spaces only; it is
 * rendered in the Redacted Script font so it reads as data but is illegible.
 */

var LETTERS = 'abcdefghijklmnopqrstuvwxyz';

// djb2 string hash, unsigned
function hashString(str) {
  var hash = 5381;
  for (var i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) >>> 0;
  }
  return hash;
}

// Small deterministic generator seeded from the hash (mulberry32)
function makeRandom(seed) {
  var state = seed >>> 0;
  return function() {
    state = (state + 0x6d2b79f5) >>> 0;
    var t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function randomInt(random, min, max) {
  return min + Math.floor(random() * (max - min + 1));
}

function word(random, length) {
  var out = '';
  for (var i = 0; i < length; i++) {
    out += LETTERS.charAt(Math.floor(random() * 26));
  }
  return out;
}

function dateText(random, seed) {
  var text = word(random, 10);
  if (seed % 2 === 0) {
    text += ' ' + word(random, 6);
  }
  return text;
}

function placeholderCellFor(field, rowIndex) {
  var identity = field && (field.suuid || field.fieldSUUID || field.title);
  var attribute = field && field.fieldAttribute;
  var type = field && field.type;
  var seed = hashString(identity + '|' + attribute + '|' + rowIndex);
  var random = makeRandom(seed);
  var cell = { kind: 'text', text: '', align: 'left', value: false };

  if (attribute === 'user') {
    cell.text = word(random, randomInt(random, 4, 7)) + ' ' + word(random, randomInt(random, 5, 8));
  } else if (attribute === 'timestamp') {
    cell.text = dateText(random, seed);
  } else if (type === 'photo' || type === 'image' || (field && field.meta && field.suuid === 'photo')) {
    cell.kind = 'image';
  } else if (type === 'boolean') {
    cell.kind = 'boolean';
    cell.value = seed % 2 === 0;
  } else if (type === 'dateTime' || type === 'records') {
    cell.text = dateText(random, seed);
  } else if (type === 'number') {
    cell.text = word(random, randomInt(random, 2, 5));
    cell.align = 'right';
  } else if (type === 'selector') {
    cell.text = word(random, randomInt(random, 4, 9));
  } else if (
    type === 'email' ||
    type === 'url' ||
    type === 'phone' ||
    (field && field.meta && (field.suuid === 'uuid' || field.suuid === 'url'))
  ) {
    cell.text = word(random, randomInt(random, 12, 18));
  } else {
    var count = randomInt(random, 1, 3);
    var words = [];
    for (var i = 0; i < count; i++) {
      words.push(word(random, randomInt(random, 3, 9)));
    }
    cell.text = words.join(' ');
  }
  return cell;
}

export { placeholderCellFor };
